// Descărcarea unui fișier generat de server în modulul Protecția datelor. URL-ul obiectului se revocă după o secundă,
// ca registrul și detaliul dovezii: unele browsere pornesc descărcarea asincron și o anulează dacă URL-ul e deja revocat.
export const REVOKE_DELAY_MS = 1000;

export const saveDownloadedBlob = (blob, filename, { win = window, doc = document } = {}) => {
  const url = win.URL.createObjectURL(blob);
  Object.assign(doc.createElement("a"), { href: url, download: filename }).click();
  win.setTimeout(() => win.URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};
